export enum FieldType {
  Text = 'Text',
  LongText = 'LongText',
  StaticText = 'StaticText',
  MaskText = 'MaskText',
  Numeric = 'Numeric',
  Date = 'Date',
  Datetime = 'Datetime',
  Time = 'Time',
  Rating = 'Rating',
  Select = 'Select',
  OptionList = 'OptionList',
  YesNo = 'YesNo', // Yes / No / NA
  Toggle = 'Toggle',
  CheckBox = 'CheckBox',
  EmbeddedPhoto = 'EmbeddedPhoto',
  TakePicture = 'TakePicture',
  Video = 'Video',
  DocumentViewer = 'DocumentViewer',
  UploadFile = 'UploadFile',
  WebLink = 'WebLink',
  EmailAddress = 'EmailAddress',
  Birthdate = 'Birthdate',
  Payment = 'Payment',
  Acknowledgment = 'Acknowledgment',
  Captcha = 'Captcha',
  Signature = 'Signature',
  HTML = 'HTML',
  PaymentZone = 'PaymentZone',
  PaymentOptionList = 'PaymentOptionList',
  PaymentChoiceList = 'PaymentChoiceList',
  Products = 'Products',
}

export enum FieldIcon {
  Text = 'mdi-form-textbox',
  LongText = 'mdi-form-textarea',
  StaticText = 'mdi-format-color-text',
  MaskText = 'mdi-cog-outline',
  Numeric = 'mdi-numeric',
  Date = 'mdi-calendar',
  Datetime = 'mdi-calendar-clock',
  Time = 'mdi-clock-time-four-outline',
  Rating = 'mdi-star',
  Select = 'mdi-view-list-outline',
  OptionList = 'mdi-format-list-bulleted',
  YesNo = 'mdi-format-list-bulleted', // Yes / No / NA
  Toggle = 'mdi-toggle-switch-off-outline',
  CheckBox = 'mdi-checkbox-marked-outline',
  EmbeddedPhoto = 'mdi-image',
  TakePicture = 'mdi-cog-outline',
  Video = 'mdi-video',
  DocumentViewer = 'mdi-file-document-multiple',
  UploadFile = 'mdi-upload',
  WebLink = 'mdi-link',
  EmailAddress = 'mdi-at',
  Birthdate = 'mdi-cake-variant',
  Payment = 'mdi-cog-outline',
  Acknowledgment = 'mdi-checkbox-marked-outline',
  Captcha = 'mdi-cog-outline',
  Signature = 'mdi-draw',
  HTML = 'mdi-language-html5',
  PaymentZone = 'mdi-credit-card-outline',
  PaymentOptionList = 'mdi-format-list-bulleted',
  PaymentChoiceList = 'mdi-format-list-bulleted',
  Products = 'mdi-cart-outline',
}
